var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaeger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;}\r\n\t.st1{fill:#474647;}\r\n\t.st2{fill:#777775;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,23.2c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5 C36.5,24.8,34.9,23.2,32.9,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.7,23.2c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5 C54.3,24.8,52.7,23.2,50.7,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,41.2c-0.6,0-1.1,0-1.7-0.1v21.7c0,6.6-5.4,11.9-11.9,11.9c-6.6,0-11.9-5.4-11.9-11.9V62h7.1 c5.8,0,10.5-4.7,10.5-10.5v-16c0-3.6-1.9-6.8-4.7-8.7c0,1.2-0.4,2.4-1.1,3.3c1.5,1.3,2.5,3.3,2.5,5.4v16c0,4-3.2,7.2-7.2,7.2H33.1 c-4,0-7.2-3.2-7.2-7.2v-16c0-2.2,1-4.1,2.5-5.4c-0.7-0.9-1.1-2-1.2-3.3c-2.8,1.9-4.6,5.1-4.6,8.7v16c0,5.8,4.7,10.5,10.5,10.5h7.1 v0.7c0,8.4,6.8,15.2,15.2,15.2c8.4,0,15.2-6.8,15.2-15.2V41C70.2,41.1,69.6,41.2,69.1,41.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,39c-4.1,0-7.5-3.4-7.5-7.5c0-4.1,3.4-7.5,7.5-7.5c4.1,0,7.5,3.4,7.5,7.5C76.5,35.6,73.2,39,69.1,39z  M69.1,27.5c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C73.1,29.3,71.3,27.5,69.1,27.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.9,22.2c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5 C37.4,23.8,35.8,22.2,33.9,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.7,22.2c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5 C55.2,23.8,53.6,22.2,51.7,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70,40.2c-0.6,0-1.1,0-1.7-0.1v21.7c0,6.6-5.4,11.9-11.9,11.9c-6.6,0-11.9-5.4-11.9-11.9V61h7.1 c5.8,0,10.5-4.7,10.5-10.5v-16c0-3.6-1.9-6.8-4.7-8.7c0,1.2-0.4,2.4-1.1,3.3c1.5,1.3,2.5,3.3,2.5,5.4v16c0,4-3.2,7.2-7.2,7.2H34 c-4,0-7.2-3.2-7.2-7.2v-16c0-2.2,1-4.1,2.5-5.4c-0.7-0.9-1.1-2-1.2-3.3c-2.8,1.9-4.6,5.1-4.6,8.7v16C23.5,56.3,28.2,61,34,61h7.1 v0.7C41.2,70.2,48,77,56.4,77c8.4,0,15.2-6.8,15.2-15.2V40.1C71.1,40.1,70.6,40.2,70,40.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70,38c-4.1,0-7.5-3.4-7.5-7.5c0-4.1,3.4-7.5,7.5-7.5c4.1,0,7.5,3.4,7.5,7.5C77.5,34.6,74.1,38,70,38z  M70,26.5c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C74,28.3,72.2,26.5,70,26.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaeger);
export default __webpack_public_path__ + "static/media/Laeger.bce426d98c9b9f70a7ea5f8d2ceda1a3.svg";
export { ForwardRef as ReactComponent };